import {
    buildRecordLifecyclePagedListActions,
    type RecordLifecycleConfirmKind,
} from "../../utils/navigation/recordLifecycleActions";
import { EntityLabels } from "../../utils/navigation/pageTitles";
import type { IProcessorListRow } from "../../customTypings/processor/Processor";

export type ProcessorAdminConfirmKind = RecordLifecycleConfirmKind;

export function formatProcessorToastLabel(name: string | undefined): string {
    const t = typeof name === "string" ? name.trim() : "";
    return t.length > 0 ? t : EntityLabels.processor;
}

export function getProcessorAdminActionSuccessMessage(
    kind: ProcessorAdminConfirmKind,
    name: string | undefined
): string {
    const label = formatProcessorToastLabel(name);
    const successByKind: Record<ProcessorAdminConfirmKind, string> = {
        disable: `${label} disabled successfully!`,
        enable: `${label} enabled successfully!`,
        softDelete: `${label} deleted successfully!`,
        restore: `${label} restored successfully!`,
    };
    return successByKind[kind];
}

export const buildProcessorAdminPagedListActions = buildRecordLifecyclePagedListActions<IProcessorListRow>;

export function canMutateProcessors(roleNames: string[]): boolean {
    const allowed = new Set([
        "System Administrator",
        "Administrator",
        "Office Staff",
        "Yard Staff",
    ]);
    return roleNames.some((r) => allowed.has(r));
}
